import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { ChangePassword } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'

export default class ChangePasswordModal extends Component {
  static propTypes = {
    modalId: PropTypes.string
  }

  render() {
    const { modalId } = this.props

    return (
      <MaterialModal.Body
        id={modalId}
        title={
          <FormattedMessage
            id="title.change_password"
            defaultMessage="Change password"
          />
        }
      >
        <MaterialModal.Content>
          <ChangePassword />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
